import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

function PointSolidSheet({ image = "", title = "", subtitle = "", points = [], children }) {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyItems: "center",
      borderRadius: "25px",
      gap: '2rem',
      width: '100%',
      backgroundColor: "primary.background",
      padding: { xs: "4rem 2rem", sm: "5rem" },
      height: "100%",
    }}>

      {image && <Box sx={{
        color: "white",
        width: "fit-content",
        margin: "0rem auto"
      }}>
        <Box
          component="img"
          src={image}
          sx={{
            height: "4.8rem",
            width: "4.8rem",
            display: "flex",
            justifyContent: "center",
            objectFit: "contain",
          }}
          alt=""
        />
      </Box>}

      <Typography
        sx={{
          fontSize: { xs: "3.6rem", sm: "4.8rem" },
          fontWeight: 800,
          lineHeight: "4.2rem",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: "1.6rem",
          fontWeight: 600,
          color: "rgba(255, 255, 255, 0.75)",
        }}
      >
        {subtitle}
      </Typography>

      {/* PLAN PERKS */}
      <Box sx={{ margin: "2rem 0" }}>
        {children}
      </Box>
    </Box >
  );
}

PointSolidSheet.propTypes = {
  window: PropTypes.func,
};

export default PointSolidSheet;


